<template>

   <component :is="activeComponent"></component>
</template>

<script>

   import ReportInit from '../components/Report.Init';
   import ReportScreenInit from '../components/Report.Screenproof.Init';
   import ReportScreenCreated from '../components/Report.Screenproof.Created';
   import ReportScreenCompilling from '../components/Report.Screenproof.Compilling';
   import ReportTimeproofInit from '../components/Report.Timeproof.init';
   import ReportTimeproofCreated from '../components/Report.Timeproof.Created';
   import ReportTimeproofCompilling from '../components/Report.Timeproof.Compiling';
   import ReportSignproofInit from '../components/Report.Signproof.Init';
   import ReportSignproofSign from '../components/Report.Signproof.Sign';
   import ReportSignproofCompilling from '../components/Report.Signproof.Compiling';
   import ReportSignproofInvite from '../components/Report.Signproof.Invite';
   import AnalysisInit from '../components/Analysis.Init';
   import AnalysisPicInit from '../components/Analysis.Pic.Init';
   import AnalysisPicCreated from '../components/Analysis.Pic.Created';
   import AnalysisPicCompilling from '../components/Analysis.Pic.Compilling';

   import {mapGetters} from 'vuex';
   import {SET_BREADCRUMB} from "@/core/store/modules/breadcrumbs";
   import {CHANGE_COMPONENT} from '../../core/store/modules/report';

   export default {
      name: "CreateReport",
      data() {
         return {};
      },
      components: {
         appReportInit: ReportInit,
         appReportScreenInit: ReportScreenInit,
         appReportCompiling: ReportScreenCompilling,
         appReportCreated: ReportScreenCreated,

         appReportTimeproofInit: ReportTimeproofInit,
         appReportTimeproofCompilling: ReportTimeproofCompilling,
         appReportTimeproofCreated: ReportTimeproofCreated,

         appReportSignproofInit: ReportSignproofInit,
         appReportSignproofSign: ReportSignproofSign,
         appReportSignproofCompilling: ReportSignproofCompilling,
         appReportSignproofInvite: ReportSignproofInvite,

         appAnalysisInit: AnalysisInit,
         appAnalysisPicInit: AnalysisPicInit,
         appAnalysisPicCreated: AnalysisPicCreated,
         appAnalysisPicCompilling: AnalysisPicCompilling
      },
      computed: {
         ...mapGetters([
            'activeComponent'
         ])
      },
      beforeCreate() {
         this.$store.dispatch(CHANGE_COMPONENT, 'appReportInit');
         this.$store.dispatch(SET_BREADCRUMB, [{title: "Create a Report"}]);
      }
   };
</script>